module.exports = __webpack_public_path__ + "img/academy_tools.b0f1f8b5.png";